import React, { PureComponent } from 'react'
import { withRoutingTracker } from '../HOC/withRoutingTracker.js'
import { connect } from 'react-redux'
import SeoText from './SeoText/index.js'
import { sendGtag } from '../utils/utils'

class DesignerBody extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      viewedItem: false,
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { general } = this.props
    const { viewedItem } = this.state

    if (!viewedItem && general?.type?.id) {
      sendGtag('view_item', null, {
        items: [
          {
            item_id: `#${general?.type?.id.toString()}`,
            item_name: general?.type?.name,
          }
        ],
      })

      this.setState({
        viewedItem: true
      })
    }
  }

  render() {
    const { currentLocationIndex, location, urls, general } = this.props

    const currentStep =
      location.pathname !== '/' && currentLocationIndex !== 1
        ? urls[currentLocationIndex - 2]
        : undefined
    const currentParam = currentStep?.replace('/', '')

    // TODO: Seems duplicate, delete if not needed
    // if (['type', 'shape', 'set'].includes(currentParam)) {
    //   return (
    //     <div
    //       className={`designer-body designer-body__background designer-body__background--${currentParam}`}
    //     >
    //       {this.props.children}
    //     </div>
    //   )
    // }

    return (
      <>
        <div className="background-gradient">
          <div
            className={`designer-body designer-body__background designer-body__background--${currentParam}`}
          >
            {this.props.children}
          </div>
        </div>
        <SeoText
          name={name}
          step={currentLocationIndex - 1}
          attributes={general?.type?.attributes}
          customNote={general?.shape?.slug === 'custom'}
        />
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  general: state.general,
})

export default withRoutingTracker(connect(mapStateToProps)(DesignerBody))
